import { styled } from '@mui/material'
import { colorPalette } from '../../../../style/colorPalette'

export const RangeInputWrapper = styled('div')({
  width: '50%',
})

// セルを左右に分ける区切り。セルの罫線と同じ高さまで引くとセルが2つに割れて
// 見えるため、高さを抑えた短い線にする。
const DividerSpan = styled('span')({
  backgroundColor: colorPalette.monotone[3],
  width: '1px',
  height: '60%',
  margin: '0 4px',
  flexShrink: 0,
})
export const RangeDivider = () => <DividerSpan />
